var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"athleteview"},[_c('div',{attrs:{"id":"left-pane"}},[_c('WeekSummary',{attrs:{"activities":_vm.activities}})],1),_c('div',{attrs:{"id":"athleteview-content"}},[_vm._l((_vm.activities.slice(1).slice(-5).reverse()),function(activity,i){return [_c('ActivitySummary',{key:i,attrs:{"activity":activity}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }